import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AlertTriangle, Home, ArrowLeft, HelpCircle } from 'lucide-react';

const NotFound = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-[#00152E] px-4">
      <div className="max-w-md w-full text-center">
        {/* Icon */}
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 rounded-full bg-red-100 dark:bg-red-900/20 flex items-center justify-center">
            <AlertTriangle className="w-10 h-10 text-red-500 dark:text-red-400" />
          </div>
        </div>

        {/* Heading */}
        <h1 className="text-7xl font-extrabold text-gray-200 dark:text-[#1a3884] mb-2 select-none">
          404
        </h1>
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-3">
          Page Not Found
        </h2>

        {/* Path display */}
        <div className="mb-6">
          <p className="text-sm text-gray-500 dark:text-gray-400 mb-2">
            The page you were looking for doesn't exist:
          </p>
          <code className="inline-block px-3 py-1.5 bg-gray-100 dark:bg-white/10 text-gray-700 dark:text-gray-300 rounded-lg text-sm font-mono break-all max-w-full">
            {location.pathname}
          </code>
        </div>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={() => navigate(-1)}
            className="inline-flex items-center justify-center gap-2 px-5 py-2.5 text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-white/10 border border-gray-300 dark:border-white/20 rounded-lg hover:bg-gray-50 dark:hover:bg-white/15 transition-all duration-200"
          >
            <ArrowLeft className="w-4 h-4" />
            Go Back
          </button>

          <button
            onClick={() => navigate('/dashboard')}
            className="inline-flex items-center justify-center gap-2 px-5 py-2.5 text-sm font-medium text-white bg-gradient-to-r from-[#002A5C] to-[#1a3884] rounded-lg hover:opacity-90 transition-all duration-200 shadow-md shadow-[#001030]/30"
          >
            <Home className="w-4 h-4" />
            Dashboard
          </button>
        </div>

        <p className="mt-6 text-xs text-gray-400 dark:text-gray-600">
          If you believe this is a system error, contact your administrator.
        </p>
      </div>
    </div>
  );
};

export default NotFound;
